module.exports = __webpack_public_path__ + "img/banner8.7577eddd.png";